import React, { useState } from "react";
import { get, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClock } from "@fortawesome/pro-light-svg-icons";
import { usCurrency } from "../../../../utils";
import moment from "moment";

const data = {
  bankFundings: [
    {
      bankName: "Some",
      bankFund: 1000,
    },
    {
      bankName: "Koewe",
      bankFund: 1000,
    },
    {
      bankName: "Kerw",
      bankFund: 1000,
    },
    {
      bankName: "WRwef",
      bankFund: 1000,
    },
  ],
};
const PayeeCard = () => {
  return (
    <div className="transaction-history-payee-inner-box">
      <div className="total-fee-amount-text">
        EFT (Electronic fund transfer)
      </div>
      <div className="inner-card-loan-payment">
        <div className="inner-text-fields-loan">
          <div className="response-names-transaction">Account holder</div>
          <div className="total-fee-amount-text">Account holder</div>
        </div>
        <div className="inner-text-fields-loan">
          <div className="response-names-transaction">Account holder</div>
          <div className="total-fee-amount-text">Account holder</div>
        </div>
        <div className="inner-text-fields-loan">
          <div className="response-names-transaction">Account holder</div>
          <div className="total-fee-amount-text">Account holder</div>
        </div>
        <div className="inner-text-fields-loan">
          <div className="response-names-transaction">Account holder</div>
          <div className="total-fee-amount-text">Account holder</div>
        </div>
      </div>
    </div>
  );
};
export const PaymentMethod = (props) => {
  return (
    <div className="transaction-history-withdrawal">
      <div className="transaction-history-withdrawal-header">
        Payment Method
      </div>

      {[1, 2, 3, 4, 5].map((e) => {
        return <PayeeCard />;
      })}
    </div>
  );
};
